import React from 'react';
import PropTypes from 'prop-types';

import DashboardFilters from './DashboardFilters';
import DashboardTransactions from './DashboardTransactions';
import * as S from './styled';

const AdminDashboard = ({
  filter,
  onChangeFilter,
  transactions,
  workspaces,
  transactionsCount,
  listItems,
  dayPoints,
  loadMoreTransactions,
  isItemLoaded,
  totalIncome,
  listRef,
  infiniteLoaderRef,
}) => (
  <S.Dashboard>
    <S.DashboardBody>
      <S.DashboardSidebar>
        <DashboardFilters
          filter={filter}
          onChangeFilter={onChangeFilter}
        />
      </S.DashboardSidebar>
      <S.DashboardMain>
        <DashboardTransactions
          transactions={transactions}
          workspaces={workspaces}
          transactionsCount={transactionsCount}
          listItems={listItems}
          dayPoints={dayPoints}
          totalIncome={totalIncome}
          loadMoreTransactions={loadMoreTransactions}
          isItemLoaded={isItemLoaded}
          listRef={listRef}
          infiniteLoaderRef={infiniteLoaderRef}
        />
      </S.DashboardMain>
    </S.DashboardBody>
  </S.Dashboard>
);

AdminDashboard.propTypes = {
  filter: DashboardFilters.propTypes.filter,
  onChangeFilter: PropTypes.func,
  ...DashboardTransactions.propTypes,
};

AdminDashboard.defaultProps = {};

export default AdminDashboard;
